import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { NgxPaginationModule} from 'ngx-pagination';
import { Ng2SearchPipe } from './filter.pipe';
import { Ng2OrderModule } from 'ng2-order-pipe';

import { GatewayStatusComponent } from './gateway-status.component';
import { GatewayStatusService } from './gateway-status.service';

@NgModule({
  declarations: [
    GatewayStatusComponent,
    Ng2SearchPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpModule,
    NgxPaginationModule,
    Ng2OrderModule,
    RouterModule
  ],
  providers: [GatewayStatusService],
  bootstrap: [GatewayStatusComponent],
  exports:   [Ng2SearchPipe, RouterModule]
})

export class GatewayStatusModule { }



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/gateway-status/gateway-status.module.ts